import { tvpil } from '../compat/tvpil';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchFavoriteDictionary } from './queryFunctions';

export function fetchFavoriteChannelsQuery() {
  return queryClient.fetchQuery({
    queryKey: queryKeys.favoriteChannelsDictionary,
    queryFn: () => fetchFavoriteDictionary(),
    staleTime: tvpil.favoritesTtl,
  });
}
